import images from '../img/work/*.png';

export const projects = [
  {
    name: 'countdown',
    shortName: 'Countdown',
    fullName: 'Launch Countdown Timer',
    images: 1,
    techStack: 'HTML, CSS, JavaScript',
    description:
      'Timer Application which represents passing seconds using card flips',
    liveSite: 'https://usmonbek-timer.netlify.app',
    repo: 'https://github.com/usmonbek-umarbekovich/Launch-Countdown-Timer-Main',
  },
  {
    name: 'mapty',
    shortName: 'Mapty',
    fullName: 'Mapty Workout Application',
    images: 1,
    techStack: 'HTML, CSS, JavaScript',
    description:
      'An Application where users can mark the location where they want to run/cycle',
    liveSite: 'https://usmonbek-mapty.netlify.app',
    repo: 'https://github.com/usmonbek-umarbekovich/Mapty-App',
  },
  {
    name: 'amazon-clone',
    shortName: 'Amazon Clone',
    fullName: 'Amazon Clone',
    images: 3,
    techStack: 'JavaScript, React, Node, Express, Firebase',
    description:
      'The application has everything that regular e-commerce application has. It includes authentication, products, checkout, payment system and very similar design.',
    liveSite: 'https://clone-1764d.firebaseapp.com/',
    repo: 'https://github.com/usmonbek-umarbekovich/amazon-clone',
  },
  {
    name: 'game-hub',
    shortName: 'GameHub',
    fullName: 'GameHub',
    images: 2,
    techStack: 'TypeScript, React, Chakra-UI, Zustand',
    description:
      'GameHub is a comprehensive web application dedicated to providing gamers with a centralized hub for exploring and reviewing video games.',
    liveSite: 'https://game-hub-webapp.vercel.app',
    repo: 'https://github.com/usmonbek-umarbekovich/game-hub',
  },
  {
    name: 'collection',
    shortName: 'Personal Collection',
    fullName: 'Personal Collection',
    images: 5,
    techStack: 'JavaScript, React, Node, Express, MongoDB',
    description:
      'An application that enables users to create collections and preserve their favorite items inside of them.',
    liveSite: 'https://usmonbek-collection.herokuapp.com',
    repo: 'https://github.com/usmonbek-umarbekovich/personal-collection',
  },
  {
    name: 'shoe-sphere',
    shortName: 'ShoeSphere',
    fullName: 'Shoe Sphere',
    images: 6,
    techStack: 'Next.js, React, TypeScript, Material-UI',
    description:
      'ShoeSphere is a cutting-edge web application designed to provide a seamless and enjoyable shoe shopping experience. This project is focused on creating a feature-rich eCommerce platform specifically tailored for footwear enthusiasts.',
    liveSite: 'https://shoe-sphere.vercel.app',
    repo: 'https://github.com/usmonbek-umarbekovich/shoe-sphere',
  },
];

class View {
  generateCards(parentCard) {
    projects.forEach(project => {
      const markup = `
        <li class="card" data-name="${project.name}">
          <img
            src="${images[project.name + '-1']}"
            alt="${project.shortName}"
            class="card-photo"
          />
          <div class="card-overlay">
            <p class="card-title">${project.shortName}</p>
            <button class="btn btn-primary btn-dark btn-learn">
              Learn More
            </button>
          </div>
        </li>`;
      parentCard.insertAdjacentHTML('afterbegin', markup);
    });
  }

  generateProject(project) {
    let markup = `
      <div class="image-slide-container">
        <button class="btn btn-close-modal">
          <i class="fas fa-times"></i>
        </button>
        <button class="btn btn-prev btn-secondary">
          <i class="fas fa-chevron-left"></i>
        </button>
        <button class="btn btn-next btn-secondary">
          <i class="fas fa-chevron-right"></i>
        </button>
        <ul class="project-images"></ul>
      </div>
      <p class="project-title">${project.fullName}</p>
      <p class="project-tech-stack">${project.techStack}</p>
      <p class="project-detail">
        ${project.description}
      </p>
      <div class="more-info">
        <a href="${project.liveSite}" target="_blank" class="btn btn-site">
          <i class="fas fa-external-link-alt"></i> View Site
        </a>
        <a href="${project.repo}" target="_blank" class="btn btn-repo">
          <i class="fab fa-github"></i> GitHub Repo
        </a>
      </div>`;
    document.querySelector('.project').insertAdjacentHTML('afterbegin', markup);

    const imageContainer = document.querySelector('.project-images');
    for (let i = 1; i <= project.images; i++) {
      const image = images[`${project.name}-${i}`];
      markup = `
        <li
          class="project-image"
          data-id="${(i - 1) * 100}"
          style="transform: translateX(${(i - 1) * 100}%)"
        >
          <img src="${image}" alt="Project" />
        </li>`;
      imageContainer.insertAdjacentHTML('afterbegin', markup);
    }
  }
}

export const view = new View();
